import React from 'react';
import {motion} from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const {FiExternalLink,FiStar,FiShoppingBag,FiArrowRight}=FiIcons;

const STOREFRONT_URL="https://amzn.to/4rokm6K";

const products=[
  {
    id: 1,
    name: "Chaka Chaundh - there is no AI without IA - Motivational Quotes frames",
    price: "",
    rating: 4.3,
    image: "https://m.media-amazon.com/images/I/61QqOzWycdL._SL1200_.jpg",
    category: "Home Decor",
    link: "https://amzn.to/3OJsBvm"
  },
  {
    id: 2,
    name: "XElectron 15.6 Inch Large Digital Picture Frame",
    price: "",
    rating: 4.3,
    image: "https://m.media-amazon.com/images/I/7104SKbEFaL._SL1500_.jpg",
    category: "Gadgets",
    link: "https://amzn.to/4rQ3Ko0"
  },
  {
    id: 3,
    name: "Paper Plane Design Inspirational Wall Abstract Poster",
    price: "",
    rating: 4.2,
    image: "https://m.media-amazon.com/images/I/71wWy+qj39L._SL1280_.jpg",
    category: "Art Supplies",
    link: "https://amzn.to/3Mroy6o"
  },
  {
    id: 4,
    name: "HUION Note 2-in-1 Digital Notebook Drawing Tablet With Battery-free Pen",
    price: "",
    rating: 4.2,
    image: "https://m.media-amazon.com/images/I/61pHAWdKy-L._SL1500_.jpg",
    category: "Graphic Tablets",
    link: "https://amzn.to/4ahDMUF"
  }
];

function AmazonStorefront({title="Creators' Favorites",layout="grid"}) {
  return (
    <section className="my-12 py-8 border-t border-b border-slate-100 bg-white/50 backdrop-blur-sm rounded-[2.5rem] px-6">
      <div className="flex flex-col md:flex-row md:items-center justify-between mb-8 gap-4">
        <div>
          <h3 className="text-2xl font-black text-slate-900 tracking-tighter uppercase flex items-center gap-2">
            <SafeIcon icon={FiShoppingBag} className="text-indigo-600" />
            {title}
          </h3>
          <p className="text-slate-500 text-sm font-medium">Recommended gear to bring your quotes to life</p>
        </div>
        <a 
          href={STOREFRONT_URL} 
          target="_blank" 
          rel="noopener noreferrer" 
          className="inline-flex items-center gap-2 px-6 py-2.5 bg-slate-900 text-white rounded-full text-xs font-bold uppercase tracking-widest hover:bg-slate-800 transition-all shadow-lg shadow-slate-200"
        >
          Visit Storefront <SafeIcon icon={FiExternalLink} />
        </a>
      </div>
      <div className={`grid gap-6 ${layout==='grid' ? 'grid-cols-1 sm:grid-cols-2 lg:grid-cols-4' : 'grid-cols-1 md:grid-cols-2'}`}>
        {products.map((product)=> (
          <motion.div 
            key={product.id} 
            whileHover={{y: -5}} 
            className="group bg-white rounded-3xl p-4 border border-slate-100 shadow-sm hover:shadow-xl hover:shadow-indigo-500/5 transition-all"
          >
            <div className="relative aspect-square rounded-2xl overflow-hidden mb-4">
              <img src={product.image} alt={product.name} className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700" />
              <div className="absolute top-3 right-3 bg-white/90 backdrop-blur-sm px-2 py-1 rounded-lg flex items-center gap-1 shadow-sm">
                <SafeIcon icon={FiStar} className="w-3 h-3 text-amber-500 fill-amber-500" />
                <span className="text-[10px] font-black text-slate-700">{product.rating}</span>
              </div>
            </div>
            <div className="space-y-1 mb-4">
              <span className="text-[10px] font-black text-indigo-500 uppercase tracking-widest">{product.category}</span>
              <h4 className="font-bold text-slate-900 text-sm line-clamp-1 group-hover:text-indigo-600 transition-colors">
                {product.name}
              </h4>
              <p className="text-lg font-black text-slate-900">{product.price}</p>
            </div>
            <a 
              href={product.link} 
              target="_blank" 
              rel="noopener noreferrer" 
              className="w-full py-3 bg-slate-50 group-hover:bg-indigo-600 group-hover:text-white text-slate-600 rounded-xl text-[10px] font-black uppercase tracking-widest flex items-center justify-center gap-2 transition-all"
            >
              Buy on Amazon <SafeIcon icon={FiArrowRight} className="w-3 h-3" />
            </a>
          </motion.div>
        ))}
      </div>
      <div className="mt-8 text-center">
        <p className="text-[10px] text-slate-400 font-bold uppercase tracking-[0.2em]">
          Affiliate disclosure: We may earn a commission from qualifying purchases
        </p>
      </div>
    </section>
  );
}

export default AmazonStorefront;